import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import {
  Caption,
  TabsContainerBox,
  Tab,
  TabIcon,
} from './FsInviteNewCustomerForm.style-elements';
import PersonForm from './PersonForm';
import CompanyForm from './CompanyForm';

const tabs = [
  {
    label: defaultLocales.person,
  },
  {
    label: defaultLocales.company,
  },
];

const transitionTime = 500;

interface FsInviteNewCustomerFormProps {
  onClose?: () => void;
}

const FsInviteNewCustomerForm: React.FC<FsInviteNewCustomerFormProps> = ({
  onClose,
}) => {
  const [currentTabIdx, setCurrentTabIdx] = useState<number>(0);
  const personFormInStatus = currentTabIdx === 0;
  const companyFormInStatus = currentTabIdx === 1;

  const handleTabClick = async (idx: number): Promise<void> => {
    setCurrentTabIdx(idx);
  };

  return (
    <>
      <Caption>{defaultLocales.selectCustomerType}</Caption>
      <TabsContainerBox>
        {tabs.map(({ label }, idx) => (
          <Tab
            key={label}
            value
            selected={currentTabIdx === idx}
            onClick={(): Promise<void> => handleTabClick(idx)}
          >
            <TabIcon className="tabIcon" />
            {label}
          </Tab>
        ))}
      </TabsContainerBox>
      <Box marginTop={2}>
        {personFormInStatus && (
          <PersonForm
            onClose={onClose}
            inStatus={personFormInStatus}
            transitionTime={transitionTime}
          />
        )}
        {companyFormInStatus && (
          <CompanyForm
            onClose={onClose}
            inStatus={companyFormInStatus}
            transitionTime={transitionTime}
          />
        )}
      </Box>
    </>
  );
};

export default FsInviteNewCustomerForm;
